import $ from 'jquery';

// Добавим сразу же видимость первым элементам табов
$('.header-catalog-tab-section__inner:first').addClass ('header-catalog-tab-section__inner--active');

$('.header-catalog-tab-section').hover(function() {
    // И удалим у предыдущего
    $(this).addClass('active').siblings().removeClass('active');
    $(`[data-tab=${$(this).attr("data-section")}]`).addClass('header-catalog-tab-section__inner--active')
        .siblings().removeClass('header-catalog-tab-section__inner--active')
})
